export default function TypeBasculesConfiguration($translatePartialLoaderProvider) {
    // On configure la gestion de la traduction en lui indiquant quel fichier json il doit charger pour ce module
    $translatePartialLoaderProvider.addPart('type.bascules');
}

TypeBasculesConfiguration.$inject = ['$translatePartialLoaderProvider'];
